import { NextSeo, NextSeoProps } from 'next-seo'
import React from 'react'

type Props = NextSeoProps

const SEO: React.FC<Props> = (props: Props) => <NextSeo {...props} />

export default SEO
